'use strict'

const PoolTypes = Object.freeze({
  Earn: 'earn',
  Grow: 'grow',
  Governance: 'governance'
})

module.exports = {
  PoolTypes
}
